module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "slate-int-calculator-methodology"
    }
  }, [_c('back-button', {
    on: {
      "backButtonClick": _vm.goBack
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_vm._v("Methodology")]), _vm._v(" "), _c('div', {
    staticClass: "methodology"
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/template-compiler.js?id=data-v-3aed34fe!/Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/selector.js?type=template&index=0!./components/CalculatorMethodology.vue
// module id = 110
// module chunks = 0